(function () {
  if (window.__dvxfcV6) return;
  window.__dvxfcV6 = true;

  var YEDEK_GORSEL = "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 420'%3E%3Crect x='70' y='10' width='60' height='40' rx='8' fill='%23333'/%3E%3Crect x='55' y='55' width='90' height='30' rx='6' fill='%23555'/%3E%3Crect x='40' y='90' width='120' height='310' rx='18' fill='%23777'/%3E%3Ctext x='100' y='260' font-family='Arial' font-size='30' font-weight='bold' fill='white' text-anchor='middle'%3EDVX%3C/text%3E%3C/svg%3E";
  var azHareket = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var IKON_YOL = {
    spray: 'M9 2h4v3H9V2zm-1 4h6l1.5 3.5H6.5L8 6zm-2 5h8v11a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V11z',
    droplet: 'M12 2C8.5 7 5.5 11 5.5 14.8A6.5 6.5 0 0 0 12 21.3a6.5 6.5 0 0 0 6.5-6.5C18.5 11 15.5 7 12 2z',
    disc: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
    chevronLeft: 'M15 6l-6 6 6 6',
    chevronRight: 'M9 6l6 6-6 6',
    arrowRight: 'M4 12h15M13 6l6 6-6 6'
  };
  function ikonSvg(ad) {
    var yol = IKON_YOL[ad];
    if (!yol) return '';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + yol + '"/></svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function kutuphaneYukle() {
    if (!window.gsap && !document.getElementById('dvxfc-gsap')) {
      var gs = document.createElement('script');
      gs.id = 'dvxfc-gsap';
      gs.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
      gs.onload = function () {
        document.querySelectorAll('.dvxfc-panel.dvxfc-on').forEach(function (p) { ringKur(p); sus(p, true); });
      };
      document.head.appendChild(gs);
    }
  }

  function satirlar(s) {
    return String(s || '')
      .replace(/(^|\n)(Features|How to use):/g, '$1<strong>$2:</strong>')
      .replace(/\n/g, '<br>');
  }

  function render() {
    document.querySelectorAll('section.dvxfc').forEach(function (root) {
      if (!root.querySelector('.dvxfc-nav')) renderRoot(root);
    });
  }

  function renderRoot(root) {
    var veri = root.querySelector('script.dvxfc-data');
    if (!veri) return;
    var AYAR;
    try { AYAR = JSON.parse(veri.textContent); } catch (e) { return; }
    AYAR.kategoriler = (AYAR.kategoriler || []).filter(function (k) { return k.urunler && k.urunler.length; });
    if (!AYAR.kategoriler.length) return;
    kutuphaneYukle();

    var html = '<div class="dvxfc-head"><div class="dvxfc-head-l">';
    html += '<h2 class="dvxfc-title">' + esc(AYAR.baslik) + '</h2></div>';
    html += '<p class="dvxfc-sub">' + esc(AYAR.altBaslik || '') + '</p></div>';

    html += '<div class="dvxfc-nav" role="tablist">';
    AYAR.kategoriler.forEach(function (k, i) {
      var renk = (k.urunler[0] && k.urunler[0].renk) || '#333';
      html += '<button class="dvxfc-tab' + (i === 0 ? ' dvxfc-on' : '') + '" type="button" role="tab" aria-selected="' + (i === 0) + '" style="--dvxfc-c:' + esc(renk) + ';z-index:' + Math.max(1, 10 - i) + '"><span class="dvxfc-tab-in">' +
        (k.ikon ? ikonSvg(k.ikon) : '') +
        '<span class="dvxfc-tab-txt">' + esc(k.baslik) + '</span></span></button>';
    });
    html += '</div>';

    html += '<div class="dvxfc-panels">';
    AYAR.kategoriler.forEach(function (k, i) {
      var ilk = k.urunler[0] || {};
      html += '<div class="dvxfc-panel' + (i === 0 ? ' dvxfc-on' : '') + '" data-i="0" role="tabpanel" style="background-color:' + esc(ilk.renk || '#333') + ';background-image:' + (ilk.panelBg && ilk.panelBg.indexOf('gradient') !== -1 ? esc(ilk.panelBg) : 'none') + '">';
      html += '<div class="dvxfc-grid"><div class="dvxfc-media">';
      html += '<div class="dvxfc-wm">' + esc(ilk.kod || '') + '</div>';
      html += '<div class="dvxfc-stage">';
      k.urunler.forEach(function (u, j) {
        html += '<div class="dvxfc-slide' + (j === 0 ? ' dvxfc-akt' : '') + '" data-renk="' + esc(u.renk || '#333') + '" data-panelbg="' + esc(u.panelBg || u.renk || '#333') + '" data-kod="' + esc(u.kod || '') + '"><img class="dvxfc-img" src="' + esc(u.gorsel || YEDEK_GORSEL) + '" alt="' + esc(u.ad || '') + '" loading="lazy" decoding="async"></div>';
      });
      html += '</div>';
      html += '<div class="dvxfc-rail">';
      if (k.urunler.length > 1) {
        html += '<div class="dvxfc-thumbs">';
        k.urunler.forEach(function (u, j) {
          html += '<button class="dvxfc-thumb' + (j === 0 ? ' dvxfc-akt' : '') + '" type="button" aria-label="' + esc(u.ad || 'Product ' + (j + 1)) + '"><img src="' + esc(u.gorsel || YEDEK_GORSEL) + '" alt="" loading="lazy" decoding="async"></button>';
        });
        html += '</div>';
        html += '<div class="dvxfc-arrows">' +
          '<button class="dvxfc-arrow dvxfc-prev" type="button" aria-label="Previous product">' + ikonSvg('chevronLeft') + '</button>' +
          '<button class="dvxfc-arrow dvxfc-next" type="button" aria-label="Next product">' + ikonSvg('chevronRight') + '</button></div>';
      }
      html += '</div></div>';
      html += '<div class="dvxfc-content"><div class="dvxfc-swap">';
      k.urunler.forEach(function (u, j) {
        html += '<div class="dvxfc-text' + (j === 0 ? ' dvxfc-akt' : '') + '">';
        html += '<div class="dvxfc-phead"><h3 class="dvxfc-pname">' + esc(u.ad || '') + '</h3>' + (u.kod ? '<span class="dvxfc-kod">' + esc(u.kod) + '</span>' : '') + '</div>';
        if (u.aciklama) html += '<div class="dvxfc-desc' + (u.mobilAciklama ? ' dvxfc-desktop' : '') + '">' + satirlar(esc(u.aciklama)) + '</div>';
        if (u.mobilAciklama) html += '<div class="dvxfc-desc dvxfc-mobile">' + u.mobilAciklama + '</div>';
        html += '<div class="dvxfc-foot"><div class="dvxfc-tags">';
        if (u.etiketSol) html += '<span class="dvxfc-tag">' + esc(u.etiketSol) + '</span>';
        if (u.etiketSag) html += '<span class="dvxfc-tag">' + esc(u.etiketSag) + '</span>';
        html += '</div>';
        if (u.link) html += '<a class="dvxfc-cta" href="' + esc(u.link) + '">' + esc(AYAR.butonYazi || 'Shop now') + ikonSvg('arrowRight') + '</a>';
        html += '</div></div>';
      });
      html += '</div></div></div></div>';
    });
    html += '</div>';

    root.innerHTML = html;
    root.querySelectorAll('.dvxfc-panel').forEach(function (p) { boya(p); });
    var aktifPanel = root.querySelector('.dvxfc-panel.dvxfc-on');
    ringKur(aktifPanel);
    sus(aktifPanel, true);
  }

  function boya(panel) {
    var i = parseInt(panel.getAttribute('data-i') || '0', 10);
    var slides = panel.querySelectorAll('.dvxfc-slide');
    var texts = panel.querySelectorAll('.dvxfc-text');
    var thumbs = panel.querySelectorAll('.dvxfc-thumb');
    var wm = panel.querySelector('.dvxfc-wm');
    if (!slides.length) return;
    slides.forEach(function (s, j) { s.classList.toggle('dvxfc-akt', j === i); });
    texts.forEach(function (t, j) { t.classList.toggle('dvxfc-akt', j === i); });
    thumbs.forEach(function (d, j) { d.classList.toggle('dvxfc-akt', j === i); });
    if (wm) wm.textContent = slides[i].getAttribute('data-kod') || '';
    var renk = slides[i].getAttribute('data-renk');
    var panelBg = slides[i].getAttribute('data-panelbg') || renk;
    if (panelBg) {
      if (panelBg.indexOf('gradient') !== -1) {
        panel.style.backgroundColor = renk || '#333';
        panel.style.backgroundImage = panelBg;
      } else {
        panel.style.backgroundImage = 'none';
        panel.style.backgroundColor = panelBg;
      }
    }
    if (renk) {
      var root = panel.closest('.dvxfc');
      if (root) {
        var panels = Array.prototype.slice.call(root.querySelectorAll('.dvxfc-panel'));
        var tab = root.querySelectorAll('.dvxfc-tab')[panels.indexOf(panel)];
        if (tab) tab.style.setProperty('--dvxfc-c', renk);
      }
    }
  }

  function ringKur(panel) {
    if (!panel || !window.gsap || azHareket || panel.__dvxRing) return;
    var stage = panel.querySelector('.dvxfc-stage');
    var slides = stage ? stage.querySelectorAll('.dvxfc-slide') : [];
    if (slides.length < 2) return;
    stage.classList.add('dvxfc-ring');
    panel.__dvxRing = { pos: parseInt(panel.getAttribute('data-i') || '0', 10), sway: 0, stage: stage, slides: slides, N: slides.length };
    yerlestir(panel);
    gsap.to(panel.__dvxRing, { sway: 0.045, duration: 2.6, yoyo: true, repeat: -1, ease: 'sine.inOut', onUpdate: function () { yerlestir(panel); } });
  }

  function yerlestir(panel) {
    var st = panel.__dvxRing;
    if (!st) return;
    var rx = st.stage.clientWidth * 0.30;
    var on = ((Math.round(st.pos) % st.N) + st.N) % st.N;
    st.slides.forEach(function (s, j) {
      var a = ((j - st.pos - st.sway) / st.N) * Math.PI * 2;
      var z = Math.cos(a);
      var derin = (z + 1) / 2;
      gsap.set(s, {
        xPercent: -50, yPercent: -50,
        x: Math.sin(a) * rx,
        y: z * 12,
        scale: 0.45 + 0.55 * derin,
        rotationY: -Math.sin(a) * 16,
        transformPerspective: 900,
        opacity: 0.35 + 0.65 * derin,
        zIndex: Math.round(60 + z * 40)
      });
      s.style.pointerEvents = j === on ? 'auto' : 'none';
    });
  }

  function sus(panel, tamGiris) {
    if (!panel || !window.gsap || azHareket) return;
    var img = panel.querySelector('.dvxfc-slide.dvxfc-akt .dvxfc-img');
    if (img) {
      gsap.killTweensOf(img);
      gsap.fromTo(img, { scale: 0.95, y: 8 }, { scale: 1, y: 0, duration: 0.5, ease: 'power3.out', onComplete: function () { gsap.set(img, { clearProps: 'all' }); } });
    }
    if (tamGiris) {
      var aktifText = panel.querySelector('.dvxfc-text.dvxfc-akt');
      if (aktifText) {
        gsap.fromTo(aktifText.children, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.35, stagger: 0.04, ease: 'power1.out', onComplete: function () { gsap.set(aktifText.children, { clearProps: 'all' }); } });
      }
    }
  }

  function kaydir(panel, i) {
    var N = panel.querySelectorAll('.dvxfc-slide').length;
    if (!N) return;
    var yeni = ((i % N) + N) % N;
    if (yeni === parseInt(panel.getAttribute('data-i') || '0', 10)) return;
    panel.setAttribute('data-i', yeni);
    boya(panel);
    var st = panel.__dvxRing;
    if (st && window.gsap) {
      var mod = ((st.pos % st.N) + st.N) % st.N;
      var fark = yeni - mod;
      if (fark > st.N / 2) fark -= st.N;
      if (fark < -st.N / 2) fark += st.N;
      gsap.to(st, { pos: st.pos + fark, duration: 0.85, ease: 'power3.inOut', overwrite: 'auto', onUpdate: function () { yerlestir(panel); } });
    }
    sus(panel, false);
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.dvxfc-tab');
    if (tab) {
      if (tab.classList.contains('dvxfc-on')) return;
      var root = tab.closest('.dvxfc');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.dvxfc-tab'));
      var panels = root.querySelectorAll('.dvxfc-panel');
      var idx = tabs.indexOf(tab);
      tabs.forEach(function (t) { t.classList.remove('dvxfc-on', 'dvxfc-nb'); t.setAttribute('aria-selected', 'false'); });
      panels.forEach(function (p) { p.classList.remove('dvxfc-on'); });
      tab.classList.add('dvxfc-on');
      tab.setAttribute('aria-selected', 'true');
      var oncekiTab = tab.previousElementSibling;
      if (oncekiTab && oncekiTab.classList && oncekiTab.classList.contains('dvxfc-tab')) oncekiTab.classList.add('dvxfc-nb');
      if (panels[idx]) {
        panels[idx].classList.add('dvxfc-on');
        boya(panels[idx]);
        ringKur(panels[idx]);
        yerlestir(panels[idx]);
        sus(panels[idx], true);
      }
      return;
    }
    var thumb = e.target.closest('.dvxfc-thumb');
    if (thumb) {
      var panel = thumb.closest('.dvxfc-panel');
      var thumbs = Array.prototype.slice.call(panel.querySelectorAll('.dvxfc-thumb'));
      kaydir(panel, thumbs.indexOf(thumb));
      return;
    }
    var arrow = e.target.closest('.dvxfc-arrow');
    if (arrow) {
      var p2 = arrow.closest('.dvxfc-panel');
      var yon = arrow.classList.contains('dvxfc-next') ? 1 : -1;
      kaydir(p2, parseInt(p2.getAttribute('data-i') || '0', 10) + yon);
    }
  });

  new MutationObserver(function () { render(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.dvxfc-panel.dvxfc-on').forEach(function (p) { yerlestir(p); });
  }, { passive: true });
  window.addEventListener('pageshow', render, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();